import React from 'react'

const AccountDetails = () => {
  return (
    <div>AccountDetails</div>
  )
}

export default AccountDetails